// extracted by mini-css-extract-plugin
export var notificationHost = "_dx-0";